import React from 'react';

interface ShareButtonProps {
  type: 'line' | 'url' | 'x';
  letterId?: string;
  fromName?: string;
}

const ShareButton = ({ type, letterId, fromName }: ShareButtonProps) => {
  const getConfig = () => {
    switch (type) {
      case 'line':
        return {
          icon: '/img/common/ic-line.png',
          alt: 'LINE',
          text: 'LINE',
          label: 'LINEへURLを送ります',
          className: 'c-share-button--line',
        };
      case 'x':
        return {
          icon: '/img/common/ic-x.png',
          alt: 'X',
          text: 'X',
          label: 'XへURLを送ります',
          className: 'c-share-button--x',
        };
      case 'url':
      default:
        return {
          icon: '/img/common/ic-link.png',
          alt: 'URL',
          text: 'URL',
          label: 'オリジナルアドレス',
          className: 'c-share-button--url',
        };
    }
  };

  const handleClick = async () => {
    if (!letterId) {
      window.alert('メッセージが保存されていません');
      return;
    }

    const url = `${window.location.origin}/letter/${letterId}`;

    if (type === 'url') {
      try {
        await window.navigator.clipboard.writeText(url);
        window.alert('URLをクリップボードにコピーしました');
      } catch (err) {
        console.error('クリップボードへのコピーに失敗しました:', err);
        window.alert('URLのコピーに失敗しました');
      }
    } else if (type === 'line') {
      const lineShareUrl = `https://line.me/R/msg/text/?${encodeURIComponent(url)}`;
      window.open(lineShareUrl, '_blank', 'width=600,height=400');
    } else if (type === 'x') {
      const text = `${fromName}さんよりメッセージが届きました♪`;
      const xShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}&hashtags=THELETTER,男の言葉は軽すぎる,本気の想いを届けよう`;
      window.open(xShareUrl, '_blank', 'width=600,height=400');
    }
  };

  const config = getConfig();

  return (
    <div
      className={`c-share-button ${config.className}`}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <div className='c-share-button__icon'>
        <img src={config.icon} alt={config.alt} />
      </div>
      <div className='c-share-button__text'>
        <p>
          <span>{config.label}</span>
          <strong>{config.text}</strong>
        </p>
      </div>
    </div>
  );
};

export default ShareButton;
